import {reactive, ref} from 'vue';
import {assign, pick} from 'lodash-es';
import {useRefDom} from './useRefDom';

const defaultWindow = window;

export function useDomResize(target, options = {}) {
  const { window = defaultWindow, ...observerOptions } = options;
  let observer;
  const isSupported = window && 'ResizeObserver' in window;

  const rect = reactive({ bottom: null, height: null, left: null, right: null, top: null, width: null, x: null, y: null });

  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = undefined;
    }
  };

  function handler(entries) {
    assign(rect, pick(entries[0].contentRect, ['bottom', 'height', 'left', 'right', 'top', 'width', 'x', 'y']));
  }

  function onChange(el) {
    if (isSupported && window && el) {
      observer = new window.ResizeObserver(handler);
      observer.observe(el, observerOptions);
    }
  }

  const { stop } = useRefDom({ target: ref(target), cleanup, onChange });

  return {
    stop,
    isSupported,
    rect,
  };
}
